import * as yup from "yup";

export const schema = (t: (val: string) => string) => {
    const specialityValidation = yup.object().shape({
        name: yup.string().required(t("cmn:val.required")),
    });

    return specialityValidation;
};
